import React from 'react'
import { getConfig } from '../../../../config'
import { allInstalls, InstallType, useFirstEligibleInstall } from '../../../../lib/hooks/install-eligibility'
import { withPublicAssetUrl } from '../../../../lib/utils/cdn'
import { UnsupportedButton } from '../unsupported'
import { KeyboardInstallButtonCtaProps } from './base'
import { DeviceSpecificKeyboardInstallButtonBase } from './device-specific'

const { android } = getConfig().products.keyboard

export const AndroidInstallButton: React.FC<KeyboardInstallButtonCtaProps> = (props) => {
  return (
    <DeviceSpecificKeyboardInstallButtonBase
      {...props}
      buttonImg={withPublicAssetUrl('./app-store/google-play.svg')}
      installUrl={android}
      install={InstallType.Android}
    />
  )
}

export const AndroidWithFallbacksInstallButton: React.FC<KeyboardInstallButtonCtaProps> = (props) => {
  const preferredInstall = useFirstEligibleInstall([InstallType.Android])
  switch (preferredInstall) {
    case InstallType.Android:
      return <AndroidInstallButton {...props} />
    default:
      return <UnsupportedButton alternateLinkInstallTypes={allInstalls} {...props} />
  }
}
